import {
  createFrontendModule,
  microsoftAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';

/**
 * Replaces Backstage's default sign-in page, which hardcodes
 * `providers: ['guest']`.
 *
 * The blueprint is intentionally created *without* a name so this extension
 * takes the same id as the built-in one (`sign-in-page:app`) and overrides it.
 * Giving it a name would register a second sign-in page alongside the default
 * instead of replacing it.
 *
 * Entra ID is the only provider: guest sign-in leaves an unverified identity,
 * and it is not configured on the backend in production anyway.
 */
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          title="Sign in to Quodin"
          align="center"
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Quode account',
            message: 'Sign in with your @quode.com.br account.',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
